import PatternProductsNew from '@/components/PatternProductsNew/PatternProductsList.vue';
import { createCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import { PatternProduct } from '@/shared/composables/patternProducts/patternProducts.types';

const init = async () => {
  const mountSelector = '#patterns-what-you-need';

  const getProps = (target: HTMLElement) => {
    const { patternId, defaultPatternProducts } = target.dataset;
    if (!patternId || !defaultPatternProducts) return null;

    try {
      const patternProducts = JSON.parse(defaultPatternProducts);

      return {
        patternId,
        defaultPatternProductsList: patternProducts.filter(
          (pp: PatternProduct) => pp.product_id && pp.variant_id
        )
      };
    } catch (e) {
      console.error('Failed to parse defaultPatternProducts', e);
      return null;
    }
  };

  const target = document.querySelector<HTMLElement>(mountSelector);
  if (!target) return;
  const props = getProps(target);
  if (!props) return;

  const coreApp = await createCoreVueApp(PatternProductsNew, target, props);
  coreApp.mount(target);
};

init();
